import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { APPCONFIG } from "../config";

@Injectable()
export class LogSistemaService extends BaseService {
    constructor() {
        super();
        this._api = '/api/logsistema/';        
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/logSistema.service.ts